






































import Vue, { PropType } from 'vue';

import { colors, classToHex } from '@/utils/colorUtils';

import { ISystemError } from '@/models/error/error.types';
import { SystemError } from '@/models/error/error';
import ErrorAlert from './ErrorAlert.vue';

export default Vue.extend({
  name: 'StateCard',

  components: {
    ErrorAlert
  },

  props: {
    loading: {
      type: Boolean
    },

    error: {
      type: SystemError as PropType<ISystemError>
    },

    color: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },

  computed: {
    getStatusIcon(): string {
      return this.icon;
    },

    getStatusColor(): string {
      return this.color;
    },

    getStatusHexColor(): string {
      return classToHex(
        this.getStatusColor,
        colors,
        this.$vuetify.theme.currentTheme
      );
    },

    getStatusMessage(): string {
      return this.message;
    }
  }
});
